// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_XdH","cls2":"FriendlySutdModal-cls2_Jrh FriendlySutdModal-cls1_XdH"};